var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolepixDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 430,
    viewBox: "0 0 300 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 299,
    height: 429,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 50H176V58H26V50Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 68H96V76H26V68Z",
    fill: "#B1B1B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 86H26V94H118V86Z",
    fill: "#B1B1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 220V195H117V220H92ZM93 196H116V219H93V196Z",
    fill: "#B1B1B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 251V226H117V251H92ZM93 227H116V250H93V227Z",
    fill: "#B1B1B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123 195V220H148V195H123ZM147 196H124V219H147V196Z",
    fill: "#B1B1B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123 226H129.25V232.25H123V226Z",
    fill: "#B1B1B1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.25 238.5V232.25H135.5V238.5H129.25Z",
    fill: "#B1B1B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.25 244.75H123V238.5H129.25V244.75Z",
    fill: "#B1B1B1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.25 244.75V251H135.5V244.75H141.75V251H148V244.75H141.75V238.5H148V232.25H141.75V226H135.5V232.25H141.75V238.5H135.5V244.75H129.25Z",
    fill: "#B1B1B1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 122V307H274V122H26ZM211.745 123.022V156.751H27.0206V123.022H211.745ZM27.0206 157.773H211.745V287.58H27.0206V157.773ZM212.765 157.773V287.58H272.979V157.773H212.765ZM27.0206 288.602H211.745V305.978H27.0206V288.602ZM212.765 288.602V305.978H272.979V288.602H212.765ZM212.765 156.751H272.979V123.022H212.765V156.751Z",
    fill: "#B1B1B1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31 333H30V379H31V333Z",
    fill: "#B1B1B1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48 333H47V379H48V333Z",
    fill: "#B1B1B1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65 333H64V379H65V333Z",
    fill: "#B1B1B1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82 333H81V379H82V333Z",
    fill: "#B1B1B1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99 333H98V379H99V333Z",
    fill: "#B1B1B1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116 333H115V379H116V333Z",
    fill: "#B1B1B1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133 333H132V379H133V333Z",
    fill: "#B1B1B1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150 333H149V379H150V333Z",
    fill: "#B1B1B1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M167 333H166V379H167V333Z",
    fill: "#B1B1B1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M184 333H183V379H184V333Z",
    fill: "#B1B1B1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201 333H200V379H201V333Z",
    fill: "#B1B1B1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M218 333H217V379H218V333Z",
    fill: "#B1B1B1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M235 333H234V379H235V333Z",
    fill: "#B1B1B1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M252 333H251V379H252V333Z",
    fill: "#B1B1B1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M269 333H268V379H269V333Z",
    fill: "#B1B1B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 299,
    height: 429,
    stroke: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolepixDetails);
export default __webpack_public_path__ + "static/media/bolepix-details.b7554a88a27d3cac474f70feccb9239d.svg";
export { ForwardRef as ReactComponent };